import * as _ from "lodash";
import {BaseView} from "./_BaseViews";

var template = require('templates/permissionDenied.html');

export class PermissionDeniedView extends BaseView {

    template = _.template(template);

    constructor() {
        super({
            tagName: 'div',
        })
    };

    render() {
        this.$el.html(this.template({}));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/PermissionDeniedView.ts